export default {
      id: "i-menu-media-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-menu-media",
      toString: function () {
        return this.url;
      }
    }